var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"huabeiCeng",on:{"click":function($event){return _vm.cengClick()}}},[_c('img',{attrs:{"src":require("./img/huabeiCeng_icon.png")}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }